<section class="detect-location-section">
  <div class="location-header">
    Enter your zip code
  </div>
  <div class="find-location-wrap">
    <div class="find-input-wrap">
      <input class="location-input"
             placeholder="Enter your zip code" [(ngModel)]="currentAddress"/>
      <button mat-button class="clear-icon"><span class="material-icons icon-color clear-icon" *ngIf="currentAddress" (click)="clear()">close</span></button>
    </div>

    <button *ngIf="hasRestaurants" mat-raised-button class="action-button brand-color" (click)="findAddress()" [disabled]="!currentAddress">
      Confirm
    </button>
  </div>
  <div class="spinner-wrapper"
         *ngIf="isLoading || !hasRestaurants"
    >
      <app-spinner></app-spinner>
    </div>
</section>
